import type { ProgressTone } from '@vnetwork/ui/primitives';

/**
 * Shared formatting + threshold helpers for the Capacities dashboard charts.
 * Usage thresholds follow the legacy Warehouse dashboard: <70 healthy,
 * 70–85 warning, ≥85 critical.
 */

/** Round a percentage to 1 decimal place (e.g. 63.4). */
export function pct1(value: number | null | undefined): number {
  const n = Number(value) || 0;
  return Math.round(n * 10) / 10;
}

/** Progress tone for a utilization percentage. */
export function usageTone(pct: number): ProgressTone {
  if (pct >= 85) return 'danger';
  if (pct >= 70) return 'warning';
  return 'success';
}

/** Chart/bar color token for a utilization percentage. */
export function usageColor(pct: number): string {
  if (pct >= 85) return 'var(--vn-danger-solid)';
  if (pct >= 70) return 'var(--vn-warning-solid)';
  return 'var(--vn-success-solid)';
}

/**
 * Human-readable capacity from GB — promotes to TB when large. Keeps 1 decimal
 * for TB and rounds GB to whole numbers.
 */
export function formatGb(gb: number | null | undefined): string {
  const n = Number(gb) || 0;
  if (n >= 1024) return `${(n / 1024).toFixed(1)} TB`;
  return `${Math.round(n)} GB`;
}

/** Title-case a snake/kebab status key (e.g. `in_use` → `In Use`). */
export function humanizeKey(key: string): string {
  return key
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
